import axios from 'axios';
import router from '../router/index';
import $ from 'jquery';
import Vue from 'vue';
import { Message } from 'element-ui';
const areamaps = {
    state: () => ({
        items: [],
        filter: {
            searchTerm: null,
            skip: 0,
            take: 1000,
            total: 0,
            page: 1,
        },
        selectedItems: [],
        loading: true,
    }),
    mutations: {
        setAreaMaps(state, payload) {
            state.items = payload.items;
            state.filter.total = payload.total;
        },
        setSelectedAreaMaps(state, payload) {
            state.selectedItems = payload;
        },
        setAreaMapPage(state, payload) {
            state.filter.page = payload;
            this.dispatch('getAreaMaps');
        },
        setAreaMapTake(state, payload) {
            state.filter.page = 1;
            state.filter.take = payload;
            this.dispatch('getAreaMaps');
        },
    },
    actions: {
        async getAreaMap(context, payload) {
            var res = await axios.post('/AreaMap/Get', { id: payload });
            return res;
        },
        async saveAreaMapsOrder(context, payload) {
            var res = await axios.post('/AreaMap/UpdateOrderNos', { ids: payload });
            if (res.data.alert.hasError) {
                Message.error(res.data.alert.message);
            } else {
                Message.success(res.data.alert.message);
            }
        },
        async getAreaMaps(store) {
            store.state.loading = true;
            var res = await axios.post('areamap/list', {
                ...store.state.filter,
                skip: (store.state.filter.page - 1) * store.state.filter.take,
            });
            store.state.loading = false;
            return store.commit('setAreaMaps', res.data.data);
        },
        async toggleAreaMap(store, payload) {
            var res = await axios.post('areamap/toggleisactive', {
                id: payload,
            });
            return res.data;
        },
        async deleteAreaMap(store, payload) {
            var res = await axios.post('areamap/delete', { id: payload });
            if (res.data.alert.hasError) {
                Message.error(res.data.alert.message);
            } else {
                Message.success(res.data.alert.message);
            }
            return res;
        },
    },
    getters: {},
};
export default areamaps;


// WEBPACK FOOTER //
// ./src/store/areamaps.js